const groupBy = require('lodash/fp/groupBy');
const dasherize = require('./string-utils').dasherize;
const Entities = require('html-entities').AllHtmlEntities;

const entities = new Entities();

function getJobOrg(job, teams) {
    let team = teams.find((t) => {
        const titleOverrides = t.titleOverrides || [];
        return titleOverrides.indexOf(entities.encode(job.Job_Profile)) !== -1;
    });

    if (!team) {
        team = teams.find((t) => {
            const teamCategories = t.filters || [];

            return teamCategories.indexOf(job.jobFamily) !== -1;
        });
    }

    return team ? dasherize(team.title) : 'other';
}

function addJobOrg(jobs, teams) {
    return jobs
        .filter((j) => !!j)
        .map((job) => {
            job.org = getJobOrg(job, teams);

            return job;
        });
}

function getJobsByOrg(jobs, teams) {
    const jobsWithOrg = addJobOrg(jobs, teams);

    return groupBy('org')(jobsWithOrg);
}

module.exports = {getJobsByOrg, addJobOrg, getJobOrg};
